<template>
    <div class="input-group">
        <label>{{label}}</label>
        <input :type="type" v-model="model" >
        <i class="bar"></i>
    </div>
</template>
<script>
    export default {
        name: 'inputForm',
        props: ['label', 'name', 'data', 'type'],
        computed: {
            model: {
                get() {
                    return this.data
                },
                set(val) {
                    this.$emit('input',{
                        value: val,
                        name: this.name
                    })
                }
            }
        }
    }
</script>
